<!-- eslint-disable max-lines -->
<template>
    <div class="order-panel">
        <el-tabs v-model="active" class="tabs-chenjk">
            <el-tab-pane label='全局监控' name='globalMonitoring'>
                <global-monitoring v-if="active === 'globalMonitoring'"></global-monitoring>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import globalMonitoring from './globalMonitoring';
export default {
    components: {
        globalMonitoring
    },
    data() {
        return {
            active: 'globalMonitoring'
        };
    }
};
</script>

<style lang="less">
.order-panel {

}
</style>